<div class="modal-body modal-body-text px-0 py-2">
    {{ message }}
</div>
<div class="modal-footer px-0 pt-2 pb-0">
    <button type="button" class="btn btn-primary" (click)="activeModal.dismiss('Cross click')">
        Close
    </button>
</div>
